var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.438a10.938 10.938 0 110-21.876 10.938 10.938 0 010 21.875zm0-20.313a9.375 9.375 0 100 18.75 9.375 9.375 0 000-18.75z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.086 17.188l-4.367-4.368V5.47h1.562v6.703l3.906 3.914-1.101 1.102z",
    fill: "#8E8E8E"
  })));
}

export default SvgTimeIcon;